<script setup>
import { reactive, computed, watch } from 'vue';
import { toggleCorrectNavigationOption, store } from '@/store';

import ClinicDisplay from './ClinicDisplay.vue';
import ClinicUpload from './ClinicUpload.vue';

import { getSchedule } from '@/firebase_files/schedule';
import { formatDate } from '@/libraries/DateFunctions.js'


const state = reactive({
  file: null,
  clinic: [],
  date: (new Date((new Date).getTime() - 4 * 60 * 60 * 1000)), //  adjusts for timezone
  validSchedule:computed(() => { // boolean which toggles display
    try { // hack to get around lengh undefined for promise
      return state.clinic.length > 0;
    }
    catch {
      return false;
    }
  })
});

init();


watch(()=>store.aptDone, async(newValue, old) => {
  if (old !== newValue) {
    await updateSchedule();
  }
})


/**
 * Handles date change from ClinicDate component, updates schedule
 * @param {Object} date object
 */
async function onDateChange(d) {
  state.date = d;
  state.clinic = await updateSchedule();
}

async function updateSchedule() {
  const formattedDate = formatDate(state.date); // firebase takes date as string
  getSchedule(formattedDate).then((schedule) => {
    if (schedule) {
      state.clinic = schedule;  // screen shown is dependent on length of clinic
    }
    else {
      state.clinic = [];
    }
  })
}

async function init() {
  toggleCorrectNavigationOption(); // update nav bar
  // check if schedule exists, prompt upload if not
  await updateSchedule();

}
</script>

<template>
  <!-- Show schedule if there is one available -->
  <div class="schedule-container" v-if="state.validSchedule || store.scheduleData.length">
    <ClinicDisplay class="clinic-display"
    :clinic="state.clinic" :date="state.date" 
    @date-change="(date)=>onDateChange(date)"/>
    <!-- <ClinicViewClaimsVue class="saved-claims-display" :date="state.date" /> -->
  </div>
  <!-- Else prompt upload -->
  <div v-else>
    <ClinicUpload :initial-date="state.date"
    @date-change="(d)=>onDateChange(d)"/>
  </div>
</template>

<style scoped lang="scss">
.schedule-container {
  display: flex;
  margin-bottom: 20px;
  text-align: center;
  max-width: 100%;

}
.clinic-display {
  margin: 0 1rem;
  flex: 4;
}
.saved-claims-display{
  margin: 0 1rem;
  flex: 5;
}
</style>
